import { MobileMenuBurger } from './BurgerMenu.styled';

const BurgerMenu = () => {
  return <MobileMenuBurger />;
};

export default BurgerMenu;
